var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { formatMoney, formatNumber } from '../../common/helpers';
import useFetch from '../../common/useFetch';
import DrawService from '../../domain/DrawService';
import gs from '../../styles/style';
import { UserContext } from '../Auth/UserProvider';
import { Pager, SearchInput, TableLoader, useDataframe } from '../Common/Dataframe';
import { ConfirmationModal, useModal } from '../Common/Modal';
export var Tabs;
(function (Tabs) {
    Tabs["Upcoming"] = "upcoming";
    Tabs["Verified"] = "verified";
})(Tabs || (Tabs = {}));
;
;
var DrawOverview = function (_a) {
    var _b = _a.tab, tab = _b === void 0 ? Tabs.Upcoming : _b;
    var t = useTranslation(['general', 'draw_statuses'])[0];
    var user = useContext(UserContext).user;
    return React.createElement("div", null,
        React.createElement("div", { className: gs('section-header') },
            React.createElement("h1", { className: gs('section-title') }, t('draws')),
            user.isManager() && React.createElement("div", { className: gs('section-options') },
                React.createElement(Link, { to: "/draws/add", className: gs('btn', 'btn-primary') }, t('add_draw')))),
        React.createElement("ul", { className: gs('nav', 'nav-tabs', 'mb-4') },
            React.createElement("li", { className: gs('nav-item') },
                React.createElement(Link, { to: "/draws", className: gs('nav-link', { active: tab == Tabs.Upcoming }) }, t('upcoming'))),
            React.createElement("li", { className: gs('nav-item') },
                React.createElement(Link, { to: "/draws/verified", className: gs('nav-link', { active: tab == Tabs.Verified }) }, t('verified')))),
        tab == Tabs.Upcoming && React.createElement(UpcomingDraws, null),
        tab == Tabs.Verified && React.createElement(VerifiedDraws, null));
};
var UpcomingDraws = function () {
    var t = useTranslation(['general', 'draw_statuses'])[0];
    var user = useContext(UserContext).user;
    var dataframe = useDataframe(function (config) {
        return DrawService.getDraws(__assign(__assign({}, config), { params: __assign(__assign({}, config.params), { verified: false, order_by: 'draw_at', order_direction: 'asc' }) }));
    }, {
        perPage: 10
    });
    var _a = useFetch(DrawService.deleteDraw, {
        onSuccess: function () {
            dataframe.reload();
        }
    }), deleteDraw = _a.post, deleting = _a.loading;
    var deleteModal = useModal({
        onClose: function (draw) {
            if (draw) {
                deleteDraw(draw);
            }
        }
    });
    return React.createElement("div", null,
        React.createElement("div", { className: gs('w-50') },
            React.createElement(SearchInput, { dataframe: dataframe })),
        React.createElement("table", { className: gs('table-overview', 'mt-4', { loading: dataframe.isLoading() }) },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { width: '30%' } }, t('draw')),
                    React.createElement("th", { style: { width: '12%' } }, t('status')),
                    React.createElement("th", { style: { width: '12%' } }, t('participations')),
                    React.createElement("th", { style: { width: '12%' } }, t('revenue')),
                    React.createElement("th", { style: { width: '15%' } }, t('prize_scheme')),
                    user.isManager() && React.createElement("th", null))),
            React.createElement("tbody", null,
                React.createElement(TableLoader, { dataframe: dataframe, columns: user.isManager() ? 7 : 6 }),
                dataframe.getData().map(function (draw) { return React.createElement("tr", { key: draw.id },
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/draws/".concat(draw.id) },
                            React.createElement("strong", null, draw.title))),
                    React.createElement("td", null, t("draw_statuses:".concat(draw.status))),
                    React.createElement("td", null, formatNumber(draw.participations_count)),
                    React.createElement("td", null, formatMoney(draw.revenue)),
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/prize-schemes/".concat(draw.prize_scheme.id) }, draw.prize_scheme.title)),
                    user.isManager() && React.createElement("td", { className: gs('text-right') },
                        React.createElement(Link, { to: "/draws/".concat(draw.id, "/edit"), className: gs('btn', 'btn-sm', 'btn-outline-secondary', { disabled: !draw.editable }) }, t('edit')),
                        ' ',
                        React.createElement("button", { type: "button", onClick: function () { return deleteModal.open(draw); }, disabled: !draw.deletable, className: gs('btn', 'btn-sm', 'btn-outline-danger') }, t('delete')))); }))),
        dataframe.getPageCount() > 1 && React.createElement("div", { className: gs('mt-4') },
            React.createElement(Pager, { dataframe: dataframe })),
        deleteModal.isOpen && React.createElement(ConfirmationModal, { modal: deleteModal },
            React.createElement("h5", { className: gs('my-2') }, t('confirm_delete', { title: deleteModal.props.title }))));
};
var VerifiedDraws = function () {
    var t = useTranslation()[0];
    var dataframe = useDataframe(function (config) {
        return DrawService.getDraws(__assign(__assign({}, config), { params: __assign(__assign({}, config.params), { verified: true, order_by: 'draw_at', order_direction: 'desc' }) }));
    }, {
        perPage: 10
    });
    return React.createElement("div", null,
        React.createElement("div", { className: gs('w-50') },
            React.createElement(SearchInput, { dataframe: dataframe })),
        React.createElement("table", { className: gs('table-overview', 'mt-4', { loading: dataframe.isLoading() }) },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { width: '25%' } }, t('draw')),
                    React.createElement("th", { style: { width: '10%' } }, t('participations')),
                    React.createElement("th", { style: { width: '14%' } }, t('revenue')),
                    React.createElement("th", { style: { width: '12%' } }, t('won_prizes')),
                    React.createElement("th", { style: { width: '12%' } }, t('winnings')),
                    React.createElement("th", { style: { width: '12%' } }, t('tax_amount')),
                    React.createElement("th", { style: { width: '15%' } }, t('prize_scheme')))),
            React.createElement("tbody", null,
                React.createElement(TableLoader, { dataframe: dataframe, columns: 7 }),
                dataframe.getData().map(function (draw) { return React.createElement("tr", { key: draw.id },
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/draws/".concat(draw.id) },
                            React.createElement("strong", null, draw.title))),
                    React.createElement("td", null, formatNumber(draw.participations_count)),
                    React.createElement("td", null, formatMoney(draw.revenue)),
                    React.createElement("td", null, formatNumber(draw.won_prizes_count)),
                    React.createElement("td", null, formatMoney(draw.winnings)),
                    React.createElement("td", null, formatMoney(draw.tax_amount)),
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/prize-schemes/".concat(draw.prize_scheme.id) }, draw.prize_scheme.title))); }))),
        dataframe.getPageCount() > 1 && React.createElement("div", { className: gs('mt-4') },
            React.createElement(Pager, { dataframe: dataframe })));
};
export default DrawOverview;
